import * as Yup from 'yup'

export const providerFormValidationSchema = Yup.object({
  name: Yup.string()
    .min(2, 'Enter a name more than 1 characters long')
    .required('This field is required'),
  code: Yup.string()
    .min(2, 'Enter a name more than 1 characters long')
    .matches(/^[0-9]+$/, 'Only numbers are allowed')
    .required('This field is required'),
  slogan: Yup.string().required('This field is required'),
  hostName: Yup.string().required('This field is required'),
  rateGroupName: Yup.string().required('This field is required'),
  rateGroupCode: Yup.string().required('This field is required')
})
